// src/hooks/usePageMetadata.js
import { useEffect } from "react";

const usePageMetadata = (
  title = "BioStat | Empowering Medical Research",
  description = "Empowering medical research with innovative solutions.",
) => {
  useEffect(() => {
    // Set document title
    document.title = title;

    // Helper to create or update meta tags
    const setMeta = (name, content) => {
      let metaTag = document.querySelector(`meta[name="${name}"]`);
      if (!metaTag) {
        metaTag = document.createElement("meta");
        metaTag.name = name;
        document.head.appendChild(metaTag);
      }
      metaTag.content = content;
    };

    setMeta("title", title);
    setMeta("description", description);
  }, [title, description]);
};

export default usePageMetadata;
